<template>
    <div v-bind="$attrs">
        <div class="flex align-items-center w--fit gap-2 mb--35">
            <span class="sk_base" />
            <!-- <span class="sk_base" /> -->
        </div>

        <div>
            <div class="flex flex-wrap align-items-center gap-2 w--100">
                <div class="flex flex-wrap align-items-center gap-2 w--100 mb--15" style="justify-content: space-evenly;">
                    <div v-for="item in 6" :key="item" class="sk_base" />
                </div>
                <div>
                    <div v-for="(item, index) in 8" :key="item" class="flex flex-wrap align-items-center gap-2" :class="{ 'mb--25': index !== 7}">
                        <div class="sk_base" />
                        <div class="sk_base" />
                        <div class="sk_base" />
                        <div class="sk_base" />
                        <div class="sk_base" />
                        <div class="sk_base" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SkeletonPageList",

    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.sk_base {
    min-width: 160px;
    min-height: 20px;
    background-color: #eeeeee;
    border-radius: 5px;
}
</style>